import { observer } from 'mobx-react';
import moment from 'moment';
import { FC, useState } from 'react';
import { customersProfilesStore } from '../../store';
import { localeStore } from 'src/mobx/localesStore';
import client from 'src/services/client';
import wms from 'src/services/wms';
import { downloadFile } from 'src/utils/helpers';
import Button from 'src/view/components/Controls/ButtonComponent/Button';
import logger from '~/services/logger';

const CustomersProfilesExport: FC = observer((): JSX.Element => {
  // 3 minutes
  const exportRequestTimeout: number = 3 * 60 * 1000;
  const [loading, setLoading] = useState<boolean>(false);

  const onExport = async () => {
    try {
      setLoading(true);

      const params: any = {
        search: customersProfilesStore.filters.search,
        is_delete: 0,
        status: customersProfilesStore.filters.status,
        sort_dir: customersProfilesStore.filters.sortDir,
        sort_field: customersProfilesStore.filters.sortField,
      };

      if (window.IS_MOBILE) {
        params.export_url = 1;
      } else {
        params.export = 1;
      }

      const response = await client.get('v3/crm/customers', {
        params,
        responseType: window.IS_MOBILE ? 'text' : 'blob',
        timeout: exportRequestTimeout,
      });

      if (window.IS_MOBILE) {
        await wms.downloadFile(response);
      } else {
        downloadFile(response, `Customers profiles ${moment().format('DD.MM.YYYY hh.mm.ss')}.csv`);
      }

      setLoading(false);
    } catch (error: any) {
      setLoading(false);
      logger.error({ error, place: 'CustomersProfilesExport onExport', showModal: true });
    }
  };

  return <Button title={localeStore.t('export_to_excel')} onClick={onExport} loading={loading} appearance="secondary" />;
});

export default CustomersProfilesExport;
